module.exports = __webpack_public_path__ + "img/37_153.449945b0.png";